import RecurrentActive from './RecurrentActive'
import RecurrentStopped from './RecurrentStopped'
import PropTypes from 'prop-types'
import './FlexibleNavBar.scss'

const RecurringPaymentTab = ({ billingDay, billingEndDay, billingStartDay, editSchedule, isStopped }) => (
  <div className="payments-flexible-nav-bar d-flex flex-wrap justify-content-between py-3">
    {isStopped ? (
      <RecurrentStopped {...{ billingDay, billingEndDay, billingStartDay }} />
    ) : (
      <RecurrentActive {...{ billingDay, billingStartDay, editSchedule }} />
    )}
  </div>
)

RecurringPaymentTab.defaultProps = {
  billingEndDay: '',
}


RecurringPaymentTab.propTypes = {
  billingDay: PropTypes.string.isRequired,
  billingEndDay: PropTypes.string,
  billingStartDay: PropTypes.string.isRequired,
  isStopped: PropTypes.bool.isRequired,
}

export default RecurringPaymentTab
